import { render, staticRenderFns } from "./TituloTabelaProdutosComprar.vue?vue&type=template&id=1edf0cb8&scoped=true"
import script from "./TituloTabelaProdutosComprar.vue?vue&type=script&lang=js"
export * from "./TituloTabelaProdutosComprar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edf0cb8",
  null
  
)

export default component.exports